import { render, staticRenderFns } from "./DashboardTokenStatisticTile.vue?vue&type=template&id=a9d57790&scoped=true&lang=pug"
import script from "./DashboardTokenStatisticTile.vue?vue&type=script&lang=ts"
export * from "./DashboardTokenStatisticTile.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTokenStatisticTile.vue?vue&type=style&index=0&id=a9d57790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d57790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VIcon})
